const isJSONString = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

const isString = (str: unknown): str is string => {
  return Boolean(typeof str === 'string' || str instanceof String);
};

const getString = (str: unknown): string => {
  return isString(str) ? str : '';
};

const toTitleCase = (str: string) => {
  const separators = [' ', '-', '/'];
  str = str.toLowerCase();
  const titleCase = (word: string) =>
    `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
  separators.forEach(
    (separator) => (str = str.split(separator).map(titleCase).join(separator))
  );
  return str;
};

export { isJSONString, getString, isString, toTitleCase };
